// extracted by mini-css-extract-plugin
export default {"header":"Header_header__gy-sj","h1":"Header_h1__dU8Up","h4":"Header_h4__f4L22"};